import { useState } from "react";

export default function Operations() {

  const [search, setSearch] = useState("");

  /* ===============================
     SAMPLE DATA (REPLACE WITH API)
  =============================== */
  const tasks = [
    {
      id: 1,
      task: "Client onboarding setup",
      assigned: "Maria",
      priority: "High",
      status: "In Progress",
    },
    {
      id: 2,
      task: "Update website landing page",
      assigned: "John",
      priority: "Medium",
      status: "Completed",
    },
    {
      id: 3,
      task: "Prepare monthly report",
      assigned: "Anna",
      priority: "Low",
      status: "Pending",
    },
  ];

  /* ===============================
     FILTER
  =============================== */
  const filteredTasks = tasks.filter((t) =>
    t.task.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-6">

      {/* ===============================
         HEADER
      =============================== */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-3xl font-bold">Operations</h2>
          <p className="text-gray-500">
            Manage workflows and daily operations
          </p>
        </div>

        <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition">
          Add Task
        </button>
      </div>

      {/* ===============================
         KPI CARDS
      =============================== */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Total Tasks</h4>
          <p className="text-2xl font-bold mt-2">24</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">In Progress</h4>
          <p className="text-2xl font-bold mt-2 text-yellow-600">8</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Completed</h4>
          <p className="text-2xl font-bold mt-2 text-green-600">12</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Pending</h4>
          <p className="text-2xl font-bold mt-2 text-gray-600">4</p>
        </div>

      </div>

      {/* ===============================
         SEARCH
      =============================== */}
      <div className="bg-white p-4 rounded-xl shadow-sm border">
        <input
          type="text"
          placeholder="Search tasks..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      {/* ===============================
         TASK TABLE
      =============================== */}
      <div className="bg-white rounded-xl shadow-sm border overflow-x-auto">
        <table className="w-full text-sm">

          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="p-4">Task</th>
              <th className="p-4">Assigned To</th>
              <th className="p-4">Priority</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>

          <tbody>
            {filteredTasks.length > 0 ? (
              filteredTasks.map((t) => (
                <tr key={t.id} className="border-t hover:bg-gray-50">

                  <td className="p-4 font-medium">{t.task}</td>
                  <td className="p-4">{t.assigned}</td>

                  {/* Priority */}
                  <td className="p-4">
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        t.priority === "High"
                          ? "bg-red-100 text-red-600"
                          : t.priority === "Medium"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-gray-200 text-gray-600"
                      }`}
                    >
                      {t.priority}
                    </span>
                  </td>

                  {/* Status */}
                  <td className="p-4">
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        t.status === "Completed"
                          ? "bg-green-100 text-green-700"
                          : t.status === "In Progress"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-gray-200 text-gray-600"
                      }`}
                    >
                      {t.status}
                    </span>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="p-6 text-center text-gray-500">
                  No tasks found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      {/* ===============================
         SUMMARY
      =============================== */}
      <div className="bg-white p-6 rounded-xl shadow-sm border">
        <h3 className="text-lg font-semibold mb-4">
          Operations Summary
        </h3>

        <div className="flex flex-col md:flex-row justify-between text-sm text-gray-600 gap-4">
          <p>✔ Efficiency improved by 18%</p>
          <p>✔ Task completion rate: 85%</p>
          <p>✔ Pending tasks reduced by 10%</p>
        </div>
      </div>

    </div>
  );
}